"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Öffnet ein Dialogfenster zum Umbenennen eines Layers.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.layer.GCAbstractLayer} options.layer Umzubenennder Layer
 */
gc.gis.action.layer.RenameLayer = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [this, options.layer];
};
gc.gis.action.layer.RenameLayer.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Öffnet ein Dialogfenster zum Umbenennen des übergebenen Layers.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.action.layer.RenameLayer} self Self-Reference
 * @param {gc.gis.layer.GCAbstractLayer} layer Umzubenennder Layer
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.RenameLayer.prototype.doExecute = function( self, layer )
{
	gc.gis.iface.ui.showDialog({
		type: gc.gis.widget.GCDialogType.INPUT,
		title: 'Ebene umbenennen',
		content: self.__renderContent( layer ),
		submit: function( dlg ) {
			try
			{
				var label = self.input_label.val();
				if( label )
				{
					layer.setLabel( label );
					dlg.dispose();
				}
				else
				{
					throw new gc.gis.error.GCError('Keine Bezeichnung angegeben');
				}
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );
			}
		}
	});
};

/**
 * Rendert das Formular zum Umbenennen des Layers.
 *
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer Umzubenennder Layer
 */
gc.gis.action.layer.RenameLayer.prototype.__renderContent = function( layer )
{
	var self  = this;
	this.element_description = jQuery('<p>', {
		html: 'Bitte geben Sie die neue Bezeichnung für die Ebene "<strong>'+ layer.getLabel() +'</strong>" an:'
	});
	this.element_hint = jQuery('<p>', {
		'class': 'alert alert-info',
		html: '<strong>Hinweis:</strong> Die Änderung ist nur temporär für Ihre Ebenen-Auswahl gültig und bleibt zudem beim Speichern einer Ansicht erhalten.'
	});

	this.input_label = jQuery('<input>', {
		'class': 'form-control control-input',
		type: 'text',
		placeholder: layer.getLabel(),
		value:  layer.getLabel()
	});
	var label = jQuery('<label>', {
		'class': 'control-label',
		html: '<span>Bezeichnung:</span> '
	});
	label.append( this.input_label );
    this.input_label.on('focus', function(){self.input_label.select()});
    this.input_label.focus();

	this.form = jQuery('<form>', {
		'class': 'widget-dialog-form',
		html: jQuery('<div>', {
			'class': 'form-group',
			html: label
		})
	});
	this.form.on('submit', function( evt ) {
		evt.preventDefault();
	});

	this.element_content = jQuery('<div>');
	this.element_content
		.append( this.element_description )
		.append( this.form )
		.append( this.element_hint );

	return this.element_content;
};

